import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import PersonDisplayWidget from 'Components/people/components/PersonDisplayWidget';
import {
  notableStaffCompanyName, selectAccountSelectedPeople,
  selectNotableStaffLoading,
  selectPeopleToShow, selectSapNotableStaffCount,
  selectSapNotableStaffPage, selectShowSelectedPeople,
} from 'Selector/CompaniesSelector';
import { SearchResultsRequest } from 'Types/AffinitySearchTypes';
import { Executive } from 'Types/PersonTypes';
import {
  backgroundColorParsing, formatNumberWithCommas, getCurrentTime,
  getLangCookie, validateSearchQuery, valueToObject,
} from 'Utils/UtilityFunctions';
import {
  SmartAccountTitleText, maxMobile, maxTablet, maxWidth, primaryColor, primaryFont,
  primaryHeadingColor, retina, scrollbar, secondaryFont, smMobile, wLight, wMBold, wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { actions as actionsSearch } from 'Slice/AffinitySearchResultsSlice';
import { actions } from 'Slice/CompaniesSlice';
import { actions as UiAction } from 'Slice/UISlice';
import { useSearchParams } from 'react-router-dom';
import PeopleCardListSkeleton from 'Components/common/skeleton/PeopleCardListSkeleton';
import { actions as flurryActions } from 'Slice/HelperSlice';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import { NO_PERSON_FOUND, translateSkipAreas } from 'Utils/Constants';
import {
  selectPeopleData, selectLoading, selectSearchResultsPage, selectExtendedLoading,
} from 'Selector/AffinitySearchSelector';
import { Tooltip } from 'antd';
import SmartAccountPeopleSearch from './SmartAccountPeopleSearch';

const Wrapper = styled.div`
 padding: 24px 40px 0px;
  @media all and (max-width: ${maxTablet}) {
    padding: 24px 10px 0px;
  }
.smart-heading-title-tooltip {
  display: flex;
  width: calc(100% - 15px);
  ${SmartAccountTitleText};
  @media all and (max-width: ${maxWidth}), ${retina} {
    font-size: 16px;
    line-height: 18px;
  }
  @media all and (max-width: ${maxMobile}) {
    font-size: 14px;
    line-height: 16px;
  }
  margin-bottom: 12px;
  .global-tooltip-element {
    position: relative;
    display: inline-flex;
    .section-detail-tip {
      .ant-tooltip {
        left: unset !important;
        right: 25px !important;
        top: 10px !important;
      }
    }
  }
}
.search-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 15px);
  margin-bottom: 12px;
  .search-wrapper {
    width: calc(100% - 98px);
    max-width: 344px;
    height: 35px;
    z-index: 0;
    .ant-input-affix-wrapper {
      padding-left: 6px;
      padding-right: 32px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        padding-left: 11px;
      }
      height: 35px;
      max-width: 344px;
      .ant-input-prefix {
         padding: 0px 8px 0px 4px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          padding: 0px 1px 0px 4px;
        }
        .search-global-icon-svg {
          width: 16px;
          @media all and (max-width: ${maxWidth}), ${retina} {
             width: 26px;
           }
          path {
            fill: ${primaryHeadingColor};
          }
        }
      }
      .ant-input::placeholder {
        font-weight: ${wLight} !important;
        color: #C1C1C1;
      }
    }
    .cross-icon {
      top: 10px;
      right: 10px;
      cursor: pointer;
      z-index: 1;
    }
  }
  .search-text {
    color: ${primaryColor};
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.4px;
    margin-left: 16px;
    cursor: pointer;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 14px;
    }
  }
}
.people-div {
  .company-truncate-case {
    display: flex;
    align-items: center;
  }
  .company-name-text {
    color: ${primaryHeadingColor};
    font-family: ${secondaryFont};
    font-size: 18px;
    font-weight: ${wMBold};
    line-height: 20px;
    letter-spacing: -0.562px;
    margin-bottom: 10px;
    &.notableStaff {
      white-space: pre;
    }
  }
  .search-result {
    display: flex;
    align-items: center;
    margin-top: 8px;
    margin-bottom: 0px;
    @media all and  (max-width: ${maxWidth}), ${retina}{
      margin-top: 20px;
      margin-bottom: 14px;
    }
    @media all and  (max-width: ${maxMobile}){
      margin-bottom: 0px;
    }
   .icon-span {
    margin-right: 13px;
    margin-top: 5px;
    margin-left: 11px;
    .c-pointer {
      width: 17px;
      height: 17px;
    }
   }
   .separator{
    margin-right: 5px;
    color: #dddddd;
   }
   .para-result {
    font-weight: ${wMBold};
    font-size: 14px;
    margin: 0px 10px;
    color: #1EC252;
    font-family: ${secondaryFont};
    @media all and (max-width: ${maxMobile}) {
      font-size: 14px;
      margin: 0px 5px;
    }
   }
 }
  .infinite-scroll-component__outerdiv {
    .people-wrapper-smart {
      margin: 0px !important;
      height: calc(100vh - 486px) !important;
      padding: 10px;
      margin-left: -10px !important;
      ${scrollbar};
      border-radius: 0px !important;
      @media all and (max-width: ${maxWidth}), ${retina} {
       height: calc(100vh - 426px) !important;
      }
      @media all and (max-width: ${maxTablet}) {
        height: calc(100vh - 478px) !important;
      }
      @media all and (max-width: ${smMobile}) {
        height: calc(100vh - 496px) !important;
      }
      .person-display-widget-wrapper {
        padding: 13px 14px;
        .right-side {
          .text-area {
            width: calc(100% - 18px);
          }
          .add-remove-div {
            width: 19px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              width: 20px;
              height: 20px;
              svg {
                min-height: 20px;
              }
            }
          }
        }
      }
      .no-data-wrapper {
        height: calc(100%);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .no-person-found-wrapper {
          height: unset;
          .no-person-title {
            font-size: 20px;
            color: #7E7E7E;
            margin-bottom: 0px;
          }
        }
        .view-text {
          color: ${primaryColor};
          font-family: ${primaryFont};
          font-size: 16px;
          font-weight: ${wMBold};
          line-height: 24px;
          letter-spacing: -0.556px;
          cursor: pointer;
        }
      }
    }
  }
}
`;

type Props = {
  companyStaff: Executive[]
  isActive: boolean
};

const SmartAccountPeopleTab = function SmartAccountPeopleTab(props: Props) {
  const { companyStaff, isActive } = props;
  const statement = 'You can directly search and add people into the Buyer Group of the account plan.';
  const tooltipText = 'Before you begin searching, check out the list of people from the same company you\'re preparing the Account Plan for. Choose anyone directly from the list to be part of your Buyer Group. Or you can also search and then add people.';
  const exampleText = '<ul><li>Pick the Head of IT from DELL Inc.\'s staff list to involve key decision-makers.</li><li>Search for a specific person by name and add them to your Buyer Group.</li><li>Easily manage your selections by viewing \'selected\' people and removing them if needed.</li></ul>Feel free to build your Buyer Group by selecting individuals from the company\'s notable staff list, searching by name, and managing your selections effortlessly.';
  const [searchTerm, setSearchTerm] = useState('');
  const staffCount = useSelector(selectSapNotableStaffCount);
  const formattedStaffCount = formatNumberWithCommas(staffCount);
  const companyName = useSelector(notableStaffCompanyName);
  const notableStaffPage = useSelector(selectSapNotableStaffPage);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  const selectedPeople = useSelector(selectAccountSelectedPeople);
  const showSelectedPeople = useSelector(selectShowSelectedPeople);
  const peopleToShow = useSelector(selectPeopleToShow);
  const notableStaffLoading = useSelector(selectNotableStaffLoading);
  const searchLoading: boolean = useSelector(selectLoading);
  const extendedLoading: boolean = useSelector(selectExtendedLoading);
  const { count, linkedInCount } = useSelector(selectPeopleData);
  const searchPage = useSelector(selectSearchResultsPage);
  const startTime = getCurrentTime();
  const totalCount = linkedInCount ? count + linkedInCount : count;
  const formattedTotalCount = formatNumberWithCommas(totalCount);

  useEffect(() => {
    if (showSelectedPeople) {
      dispatch(actions.setPeopleToShow(selectedPeople));
    }
  }, [selectedPeople]);

  const sendSearchCall = (keyword: string, pageCount = 1) => {
    const obj: SearchResultsRequest = {
      query: keyword.trim(),
      screenName: 'company',
      page: pageCount,
      sortCompanyId: companyIdParsed,
      defaultLanguage: getLangCookie(),
      inSap: true,
    };
    dispatch(actionsSearch.affinitySearchResultsLoading(obj));
  };

  const onSearching = (keyword: string) => {
    dispatch(actions.setShowSelectedPeople(false));
    if (keyword.length) {
      const searchQuery = validateSearchQuery(keyword.trim());
      if (searchQuery.length === 0 || searchQuery === searchTerm) {
        return;
      }
      setSearchTerm(searchQuery);
      dispatch(actionsSearch.affinitySearchResultReset());
      sendSearchCall(searchQuery, 1);
      dispatch(flurryActions.callFlurryEvent(
        valueToObject(`accountPlan_clickPersonSearch_${searchQuery}`, startTime, {}),
      ));
    } else {
      setSearchTerm('');
      dispatch(actions.setPeopleToShow(companyStaff));
      dispatch(actionsSearch.affinitySearchResultReset());
    }
  };

  const getMorePeople = () => {
    if (!showSelectedPeople) {
      dispatch(actions.getNotableStaff({
        page: notableStaffPage,
        companyId: companyIdParsed,
        screenName: 'sap',
      }));
    }
  };

  const personIsAdded = (flag: boolean) => {
    if (searchTerm.length) {
      return !flag;
    }
    return flag;
  };

  useEffect(() => {
    if (showSelectedPeople) {
      dispatch(actions.setPeopleToShow(selectedPeople));
    } else if (searchTerm === '') {
      dispatch(actions.setPeopleToShow(companyStaff));
    }
  }, [showSelectedPeople]);

  const toggleSelected = () => {
    dispatch(actions.setPeopleToShow([]));
    dispatch(actions.setShowSelectedPeople(!showSelectedPeople));
  };

  const handleAddPerson = (person: Executive) => {
    dispatch(actions.addAccountSelectedPeople(person));
    if (person.personType === 'LIVESEARCH') {
      dispatch(actions.getPersonProfile({
        personId: person.personId,
        type: person.personType,
        screenName: 'company',
      }));
      dispatch(UiAction.isShowUnderstandBlip(1));
    } else {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject(`accountPlan_clickAddPerson_${person.personId}`, startTime, {}),
      ));
    }
    dispatch(flurryActions.setNotification({
      message: `${person?.personName} has been added successfully`,
      proTip: false,
      rightPlacement: false,
      groupId: 0,
      classnameFlag: true,
    }));
  };

  const handleRemovePerson = (person: Executive) => {
    dispatch(actions.removeAccountSelectedPeople(person));
    dispatch(actions.removeLiveExecIds({
      id: person.personId,
      type: person.personType || '',
    }));
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(`accountPlan_removedPers_${person.personId}`, startTime, {}),
    ));
    dispatch(flurryActions.setNotification({
      message: `${person?.personName} has been removed successfully`,
      proTip: false,
      rightPlacement: false,
      groupId: 0,
      classnameFlag: true,
    }));
  };

  const handleView = () => {
    setSearchTerm('');
    dispatch(actions.setPeopleToShow(companyStaff));
    dispatch(actionsSearch.affinitySearchResultReset());
  };

  return (
    <Wrapper className={classNames({ dNone: !isActive })}>
      <h1 className="smart-heading-title-tooltip">
        {statement}
        <HeadingWithToolTip
          heightIcon="19px"
          widthIcon="16px"
          heightIconSm="20px"
          widthIconSm="13px"
          customWidth="280px"
          toolTipText={tooltipText}
          exampleText={exampleText}
          toolPlacement="bottomRight"
          midTabletFlag
          htmlFlag
        />
      </h1>
      <div className="search-div">
        <AlertsSearch
          placeholderText="Filter and search people..."
          loading={false}
          query={searchTerm}
          onSearching={onSearching}
          margin="0px"
          height="30px"
        />
        <span
          className={classNames('search-text text-truncate', { disabled: searchLoading || extendedLoading || notableStaffLoading })}
          onClick={toggleSelected}
          onKeyPress={toggleSelected}
          role="button"
          tabIndex={-1}
        >
          {showSelectedPeople ? 'Back' : (
            <span>
              Selected
              {` (${selectedPeople?.length})`}
            </span>
          )}
        </span>
      </div>
      <div className="people-div">
        {searchTerm.length && !showSelectedPeople && !(searchLoading && searchPage === 1) ? (
          <h3 className="company-name-text text-truncate">
            Matching People
            <span className={` ${translateSkipAreas}`}>{` (${formattedTotalCount})`}</span>
          </h3>
        ) : null}
        {searchTerm === '' && !showSelectedPeople ? (
          <span className="company-truncate-case">
            <Tooltip
              placement="top"
              getPopupContainer={(e: HTMLElement) => e}
              className="triggers-bullet-tooltip"
              color="#fff"
              title={companyName}
              zIndex={1}
              arrow={false}
            >
              <h3 className="company-name-text text-truncate">
                Also Viewed at
                {' '}
                {' '}
                {companyName}
              </h3>
            </Tooltip>
            <h3 className="company-name-text notableStaff ml-1">
              <span className={` ${translateSkipAreas}`}>{` (${formattedStaffCount})`}</span>
            </h3>
          </span>
        ) : null}
        {showSelectedPeople ? (
          <h3 className="company-name-text text-truncate">
            Selected People
            <span className={` ${translateSkipAreas}`}>{` (${selectedPeople?.length})`}</span>
          </h3>
        ) : null}
        {searchTerm === '' || showSelectedPeople ? (
          <InfiniteScroll
            hasMore
            dataLength={peopleToShow?.length ?? 0}
            next={getMorePeople}
            loader={false}
            className={classNames('people-wrapper-smart  o-x-hidden')}
            height="auto"
          >
            {peopleToShow?.map((v: Executive) => (
              <PersonDisplayWidget
                personId={v.personId}
                title={v.personName}
                profilePic={v.personImage}
                persona={backgroundColorParsing(v.personalityTypes)}
                company={v.companyName}
                designation={v.personDesignation}
                isPersonAdded={personIsAdded(v.personAdded)}
                isFollowed={v.personAdded}
                personType={v.personType}
                isRecommended
                clicked={v.isAddClicked}
                showAddIcon
                onClickAdd={() => handleAddPerson(v)}
                onClickRemove={() => handleRemovePerson(v)}
                companyId={v?.companyId}
                location={v?.location}
              />
            ))}
            {notableStaffLoading
              || (peopleToShow?.length < companyStaff?.length && !showSelectedPeople)
              ? [1, 2].map(() => (
                <PeopleCardListSkeleton />
              )) : null}
            {peopleToShow?.length < 1 && !notableStaffLoading
              ? (
                <div className="no-data-wrapper">
                  {showSelectedPeople ? (
                    <>
                      <NoPersonsFound title="No Person Selected" />
                      <span
                        className="view-text"
                        onClick={toggleSelected}
                        onKeyPress={toggleSelected}
                        role="button"
                        tabIndex={-1}
                      >
                        View People
                      </span>
                    </>
                  ) : null}
                  {!showSelectedPeople && !companyStaff?.length
                    ? <NoPersonsFound title={NO_PERSON_FOUND} /> : null}
                </div>
              )
              : null}
          </InfiniteScroll>
        )
          : (
            <SmartAccountPeopleSearch
              totalCount={totalCount}
              searchTerm={searchTerm}
              handleView={handleView}
              handleAddPerson={handleAddPerson}
              handleRemovePerson={handleRemovePerson}
            />
          )}
      </div>
    </Wrapper>
  );
};

export default SmartAccountPeopleTab;
